module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 2_Skills_List with check.36c170c5.svg";